export const COMMITMENT_OPTIONS = [
  { label: 'Full-time', value: 'full_time' },
  { label: 'Part-time', value: 'part_time' },
] as const;

export const DELIVERY_METHOD_OPTIONS = [
  { label: 'In person', value: 'in_person' },
  { label: 'Online', value: 'online' },
] as const;

export const LANGUAGE_PROGRAM_OPTIONS = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
] as const;

export const LENGTH_UNIT_OPTIONS = [
  { label: 'Years', value: 'years' },
  { label: 'Months', value: 'months' },
  { label: 'Weeks', value: 'weeks' },
] as const;

export const WORK_PRACTICUM_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
] as const;

export const TYPE_OF_PROGRAM_OPTIONS = [
  { label: 'Academic', value: 'academic' },
  { label: 'Vocational', value: 'vocational' },
] as const;
